import React, { useState } from 'react';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, Button, Tooltip } from '@mui/material';
import { Input, Spin } from 'antd';
import ButtonAnt from 'antd/lib/button';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import { Crypter } from '../../../../Functions/Security/Crypter';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import Data from '../../../../Data/Data.json'
import Utilisateur from '../../../../Models/Utilisateur';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';

interface SelectData {
  value: string,
  label: string,
}


let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchAgence: Params = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchGroup: Params = { CodeAgence: '', Table: "GROUPUSER", Colonne1: "CODGROUP", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }


function Tab2(props: { form?: any }) {
  const [garantie, SetGarantie] = React.useState<SelectData[]>([]);
  const [Donnee, setDonnee] = React.useState<any[]>([]);
  const [pageIsLoad, setPageIsLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [valeur, setvaleur] = useState<string>();
  const [montant, setMontant] = useState<number>(0);
  const [pourcentage, setPourcentage] = useState<number>(0);
  const [valeursDeGarantie, setValeursDeGarantie] = useState<number>(0)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);


  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const columns: ColumnsType<any> = [
    {
      title: 'Reférence',
      key: 'NUMRAP',
      render: (_, record: any) => (
        <>
          <Button size='small' color={(record.CDETAT == '12') ? "primary" : (record.CDETAT == '16') ? "success" : (record.CDETAT == '06') ? "error" : "inherit"} variant='contained' style={{ boxShadow: 'none' }}>{record.NUMRAP}</Button>
          <br />
          <p style={{ textAlign: "center" }}>{record.CDETAT == "13" ? "En attente de validation" : record.CDETAT == "12" ? "En attente de confirmation" : record.CDETAT == "16" ? "Opération confirmé" : record.CDETAT == "06" ? "Opération regeté" : ""}</p>

        </>
      ),
    },
    {
      title: 'Compte',
      dataIndex: 'NODUCP',
    },
    {
      title: 'Libellé',
      dataIndex: 'LIBELL',
    },
    {
      title: 'Date',
      dataIndex: 'DATECR',
    },
    {
      title: 'Remettant',
      dataIndex: 'REMETT',
    },
    {
      title: 'CNI Remettant',
      dataIndex: 'cniremet',
    },
    {
      title: 'Montant',
      dataIndex: 'MONTAN',
    },
    {
      title: 'Motif',
      dataIndex: 'LIBELL',
    },
    {
      title: 'Libellé Opération',
      dataIndex: 'LIBOPE',
    },
    {
      title: <Tooltip title='Solde après opération'><p>SAO</p></Tooltip>,
      dataIndex: 'soldeApreOpe',
    },
    {
      title: 'UtiVal',
      dataIndex: 'UTIVAL',
    }

  ];

  if (pageIsLoad) {
    setPageIsLoad(false)
    LoadLitige()
  }

  function transfert(data: any) {
    var newDatas = {
      montantOpe: data.MONTAN,
    }
    try {
      setLoading(true);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetUserAbleToValidateLitige,
        headers: {
          "CypherOeration": Crypter.encrypt(JSON.stringify(newDatas)),
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
        data: Crypter.encrypt(JSON.stringify(newDatas)),
      };

      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              transfertLitige(data, res.Result.Table)
            }
            else {
              SweetAlert.fire({ title: res.Message, icon: "warning" })
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: error, icon: "error" })
        })

    } catch (error) {
      SweetAlert.fire({ title: JSON.stringify(error), icon: "error" })
    }
  }

  function transfertLitige(data: any, userVal: any) {
    var UsersVal: { [name: string]: string } = {};

    userVal.map((u: any) => {
      UsersVal[u.CODUTI] = u.CODUTI + " - " + u.NOMUTI
    })
    SweetAlert.fire({
      title: "Tranfert d'opération litiguese",
      text: "Veillez selectionner l'utilisateur qui vas valider l'opération",
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      input: 'select',
      inputOptions: UsersVal,
      inputPlaceholder: "Utilisateur qui dois valider l'opération",
      icon: 'question'
    }).then((resp) => {

      if (resp.isConfirmed) {
        if (resp.value != null && resp.value != "") {

          var newDatas = {
            NUMCPT: data.NODUCP,
            CODAGE: data.AEDUCP,
            UTISAI: user.coduti,
            NLINE: data.NLINE,
            utiVal: resp.value
          }
          try {
            setLoading(true);
            let config = {
              method: 'put',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.TransfertOperationLitigieuse,
              headers: {
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: Crypter.encrypt(JSON.stringify(newDatas)),
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                  if (res.StatutCode == 200) {
                    LoadLitige()
                    SweetAlert.fire({ title: res.Message, icon: "success" })
                    localStorage.setItem(Data.LocalVariable.reset, "1")

                  }
                  else {
                    SweetAlert.fire({ title: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: error, icon: "error" })
              })

          } catch (error) {
            SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
          }
        } else {
          SweetAlert.fire({ title: "Veillez sélectionner l'utilisateur qui doit valider l'opération", icon: "warning" })
        }
      }
    })
  }

  function regetLitige(data: any) {
    var newDatas = {
      NUMCPT: data.NODUCP,
      lib_CODOPE: data.LIBELL,
      CODAGE: data.AEDUCP,
      DateOpe: data.DATECR,
      nomClient: data.REMETT,
      DateVal: data.DEDEVR,
      montantOpe: data.MONTAN,
      CDDEVS: data.CDDEVS,
      refOpe: data.NUMRAP,
      CODOPE: data.CDLBEC,
      NOMB01: props.form.getFieldValue("NOMB01"),
      NOMB02: props.form.getFieldValue("NOMB02"),
      NOMB03: props.form.getFieldValue("NOMB03"),
      NOMB04: props.form.getFieldValue("NOMB04"),
      NOMB05: props.form.getFieldValue("NOMB05"),
      NOMB06: props.form.getFieldValue("NOMB06"),
      NOMB07: props.form.getFieldValue("NOMB07"),
      NOMB08: props.form.getFieldValue("NOMB08"),
      NOMB09: props.form.getFieldValue("NOMB09"),
      NOMB10: props.form.getFieldValue("NOMB10"),
      NOMB11: props.form.getFieldValue("NOMB11"),
      NOMB12: props.form.getFieldValue("NOMB12"),
      NOMB13: props.form.getFieldValue("NOMB13"),
      Taxe: data.TAUX,
      CNIClient: data.cniremet,
      LieuDeliv: data.lieudelrem,
      DateDeliv: data.datdelrem,
      TypeOpe: data.sensec,
      UTISAI: data.codUti,
      NLINE: data.NLINE
    }
    //alert(JSON.stringify(data))
    SweetAlert.fire({
      title: "Voulez-vous rejetter cette opération litigieuse?",
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {

        try {
          setLoading(true);
          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.RegetOperationLitigieuse,
            headers: {
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(newDatas)),
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode == 200) {
                  LoadLitige()
                  SweetAlert.fire({ title: res.Message, icon: "success" })
                  localStorage.setItem(Data.LocalVariable.reset, "1")

                }
                else {
                  SweetAlert.fire({ title: res.Message, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: error, icon: "error" })
            })

        } catch (error) {
          SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
        }
      }
    })
  }

  function ConfirmLitige(data: any) {
    //alert(JSON.stringify(data.CDLBEC))
    if (data.MONTAN == ReformatNumber(props.form.getFieldValue("TotalBilletage"))) {
      var newDatas: any = {
        NUMCPT: data.NODUCP,
        lib_CODOPE: data.LIBELL,
        CODAGE: data.AEDUCP,
        DateOpe: data.DATECR,
        nomClient: data.REMETT,
        DateVal: data.DEDEVR,
        montantOpe: data.MONTAN,
        CDDEVS: data.CDDEVS,
        refOpe: data.NUMRAP,
        CODOPE: data.CDLBEC,
        NOMB01: props.form.getFieldValue("NOMB01"),
        NOMB02: props.form.getFieldValue("NOMB02"),
        NOMB03: props.form.getFieldValue("NOMB03"),
        NOMB04: props.form.getFieldValue("NOMB04"),
        NOMB05: props.form.getFieldValue("NOMB05"),
        NOMB06: props.form.getFieldValue("NOMB06"),
        NOMB07: props.form.getFieldValue("NOMB07"),
        NOMB08: props.form.getFieldValue("NOMB08"),
        NOMB09: props.form.getFieldValue("NOMB09"),
        NOMB10: props.form.getFieldValue("NOMB10"),
        NOMB11: props.form.getFieldValue("NOMB11"),
        NOMB12: props.form.getFieldValue("NOMB12"),
        NOMB13: props.form.getFieldValue("NOMB13"),
        Taxe: data.TAUX,
        CNIClient: data.cniremet,
        LieuDeliv: data.lieudelrem,
        DateDeliv: data.datdelrem,
        TypeOpe: (data.CDLBEC == '950' || data.CDLBEC == '052') ? "VER" : (data.CDLBEC == '951' || data.CDLBEC == '051') ? "RET" : (data.CDLBEC == '955') ? "ENV" : "REC",
        UTISAI: data.UTISAI,
        NLINE: data.NLINE,

        AUTORI: data.AUTORI,
        BLOQUE: data.BLOQUE,
        CAIUTI: user.nomuti,
        NODECE: data.NODECE,
        TelBenef: data.teleph,
        utiVal: data.UTIVAL,
      }
      //alert(newDatas.typeOpe)
      SweetAlert.fire({
        title: "Voulez-vous confirmer cette opération litigieuse?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {

          try {
            setLoading(true);
            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.ConfirmOperationLitigieuse,
              headers: {
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: Crypter.encrypt(JSON.stringify(newDatas)),
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                  if (res.StatutCode == 200) {
                    LoadLitige()
                    SweetAlert.fire({ title: res.Message, icon: "success" })
                    localStorage.setItem(Data.LocalVariable.reset, "1")

                  }
                  else {
                    SweetAlert.fire({ title: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: error, icon: "error" })
              })

          } catch (error) {
            SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
          }
        }
      })
    } else {
      SweetAlert.fire({ title: 'Votre Bielletage est incorrect', icon: "warning" })
    }
  }

  function LoadLitige() {

    let search: Params = { CodeAgence: user.codage, Table: "LITIGE", Colonne1: "UTISAI", Colonne2: "", Colagence: '101', Init: user.coduti, Choix: 33 }
    setLoading(true)
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode == 200) {
            var datat: any[] = [];
            res.Result.Table.map((r: any, indice: number) => {
              //console.log(JSON.stringify(data))
              if (r.CDETAT != 16) {
                datat.push({
                  key: indice,
                  ...r
                });
              }
              setDonnee(datat);
            }
            )
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }

  function searchOpe(value: string) {

    let search: Params = { CodeAgence: '', Table: "LITIGE", Colonne1: "NUMRAP", Colonne2: "", Colagence: '101', Init: value, Choix: 33 }
    setLoading(true)
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          //alert(JSON.stringify(res))
          if (res.StatutCode == 200) {
            //setDonnee(res.Result.Table)

            var datat: any[] = [];
            res.Result.Table.map((r: any, indice: number) => {
              //console.log(JSON.stringify(data))
              datat.push({
                key: indice,
                NUMRAP: r.NUMRAP,
                NODUCP: r.NODUCP,
                LIBELL: r.LIBELL,
                DATECR: r.DATECR,
                REMETT: r.REMETT,
                cniremet: r.cniremet,
                MONTAN: r.MONTAN,
                MOTIF: r.MOTIF,
                LIBOPE: r.LIBOPE,
                soldeApreOpe: r.soldeApreOpe,
              });
              setDonnee(datat);
            }
            )
          }
          else {
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }
  const onSelectChange = (newSelectedRowKeys: any) => {
    let r = Donnee[newSelectedRowKeys]
    var newDatas = {
      NUMCPT: r.NODUCP,
      lib_CODOPE: r.LIBELL,
      CODAGE: r.AEDUCP,
      DateOpe: r.DATECR,
      nomClient: r.REMETT,
      DateVal: r.DEDEVR,
      montantOpe: r.MONTAN,
      CDDEVS: r.CDDEVS,
      refOpe: r.NUMRAP,
      CODOPE: r.CDLBEC,
      NOMB01: r.NOMB01,
      NOMB02: r.NOMB02,
      NOMB03: r.NOMB03,
      NOMB04: r.NOMB04,
      NOMB05: r.NOMB05,
      NOMB06: r.NOMB06,
      NOMB07: r.NOMB07,
      NOMB08: r.NOMB08,
      NOMB09: r.NOMB09,
      NOMB10: r.NOMB10,
      NOMB11: r.NOMB11,
      NOMB12: r.NOMB12,
      NOMB13: r.NOMB13,
      Taxe: r.TAUX,
      CNIClient: r.cniremet,
      LieuDeliv: r.lieudelrem,
      DateDeliv: r.datdelrem,
      TypeOpe: r.sensec,
      UTISAI: r.codUti,
    }
    //props.form.setFieldsValue(newDatas)
    // SweetAlert.fire({
    //   title: "Confirmation Litige\n\n" + ((newDatas.TypeOpe == 'VER') ? "VERSEMENT" : (newDatas.TypeOpe == 'RET') ? "RETRAIT" : (newDatas.TypeOpe == 'ENV') ? "ENVOI D'ARGENT" : "RECEPTION D'ARGENT ") + " " + " de " + formatNumber(parseInt(newDatas.montantOpe)) + " XAF\nPar " + newDatas.nomClient + "\nCompte : \n" + newDatas.NUMCPT,
    //   showDenyButton: true,
    //   showCancelButton: true,
    //   confirmButtonText: 'Valider',
    //   denyButtonText: 'Regété',
    //   showCloseButton: true,
    //   customClass: {
    //     actions: 'my-actions',
    //     cancelButton: 'order-1 right-gap',
    //     confirmButton: 'order-2',
    //     denyButton: 'order-3',
    //   }
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     SweetAlert.fire('Saved!', '', 'success')
    //   } else if (result.isDenied) {
    //     SweetAlert.fire('Changes are not saved', '', 'info')
    //   }
    //   setSelectedRowKeys([]);
    // })
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // setTimeout(() => {
  //   try {
  //     let reset = localStorage.getItem(Data.LocalVariable.resetTable)
  //     if (reset == "1") {
  //       setSelectedRowKeys([])
  //       localStorage.removeItem(Data.LocalVariable.resetTable)
  //     }
  //   }
  //   catch (error) { }
  // }, .1);



  return (

    <div className='tabItem'>
    </div>
  );
}

export default Tab2;